// @flow
import {
  call,
  takeEvery,
  put,
  select,
  race,
} from 'redux-saga/effects';
import { delay } from 'redux-saga';
import { normalize } from 'normalizr';
import i18n from 'i18n-js';

import * as types from '../types/gates';
import * as selectors from '../reducers';
import { REQUEST_TIMEOUT } from '../settings';
import { throwTimeout } from '../lib/http';
import * as gatesActions from '../actions/gates';
import { School, Gates } from '../api';
import HTTP_STATUS from '../lib/HTTPStatus';
import * as closeableActions from '../actions/closeable';
import * as temporalBannersActions from '../actions/temporalBanners';
import {
  DEFAULT_CREATE, DEFAULT_DURATION, DEFAULT_REMOVE, CREATE_ERROR, FETCH_ERROR, REMOVE_ERROR,
} from '../utils/errorDefaults';

import { arrayOfGates } from '../api/schemas/gates';

function* createGates(action) {
  const token = yield select(selectors.getToken);
  const profile = yield select(selectors.getProfileOfType, 'admin');
  try {
    const { gateResponse, timeout } = yield race({
      gateResponse: call(
        [Gates, 'create'],
        {
          token,
          data: {
            name: action.payload.name,
            code: action.payload.ordinal,
            school: profile.school,
            gate_type: 2,
          },
        },
      ),
      timeout: call(delay, REQUEST_TIMEOUT),
    });

    if (timeout) {
      throwTimeout('createGate saga');
    }
    yield put(temporalBannersActions.shout(DEFAULT_CREATE(i18n.t('common.gate', { count: 1 })), DEFAULT_DURATION, -1, {}));
    yield put(gatesActions.gateCreateSuccess(gateResponse));
    yield put(closeableActions.close('creategate'));
  } catch (error) {
    // Set error
    const {
      statusCode,
      message,
      data,
      isPlain,
    } = error;
    yield put(temporalBannersActions.shout(CREATE_ERROR(i18n.t('common.gate', { count: 1 })), DEFAULT_DURATION, -1, {}));
    yield put(gatesActions.gateCreateFailed({
      statusCode,
      message: statusCode === HTTP_STATUS.NOT_FOUND ? 'Error al crear puerta' : message,
      data: isPlain ? 'Error en el servidor' : data,
      retryAction: action,
    }));
  }
}

function* fetchGates(action) {
  const token = yield select(selectors.getToken);
  const id = action.payload;

  try {
    // Fetch the next route
    const { gatesResponse, timeout } = yield race({
      gatesResponse: call(
        [School.custom, 'gates'],
        { id, token },
      ),
      timeout: call(delay, REQUEST_TIMEOUT),
    });

    if (timeout) {
      throwTimeout('fetchGates saga');
    }
    const { entities, result } = normalize(
      gatesResponse,
      arrayOfGates,
    );

    yield put(gatesActions.gatesFetchSucceed(
      entities.gates,
      result,
    ));
  } catch (error) {
    // Set error
    const {
      statusCode,
      message,
      data,
      isPlain,
    } = error;
    yield put(temporalBannersActions.shout(FETCH_ERROR(i18n.t('common.gate', { count: 2 })), DEFAULT_DURATION, -1, {}));
    yield put(gatesActions.gateFetchFailed({
      statusCode,
      message,
      data: isPlain ? 'Error en el servidor' : data,
      retryAction: action,
      object_id: id,
    }));
  }
}

function* removeGate(action) {
  const id = action.payload;
  const token = yield select(selectors.getToken);
  try {
    const { timeout } = yield race({
      response: call(
        [Gates, 'remove'],
        { token, id },
      ),
    });
    if (timeout) {
      throwTimeout('Remove gate saga');
    }
    yield put(temporalBannersActions.shout(DEFAULT_REMOVE(i18n.t('common.gate', { count: 1 })), DEFAULT_DURATION, -1, {}));
    yield put(gatesActions.removeGateSuccess(id));
  } catch (error) {
    const {
      statusCode, message, data, isPlain,
    } = error;
    yield put(temporalBannersActions.shout(REMOVE_ERROR(i18n.t('common.gate', { count: 1 })), DEFAULT_DURATION, -1, {}));
    yield put(gatesActions.removeGateFailed({
      statusCode,
      message,
      data: isPlain ? 'Error en el servidor' : data,
      retryAction: action,
    }));
  }
}

export function* watchGatesFetch(): Iterator<any> {
  yield takeEvery(
    types.GATES_FETCH_STARTED,
    fetchGates,
  );
}

export function* watchGatesCreate(): Iterator<any> {
  yield takeEvery(
    types.GATE_CREATE_STARTED,
    createGates,
  );
}

export function* watchRemoveGate(): Iterator<any> {
  yield takeEvery(
    types.REMOVE_GATE_STARTED,
    removeGate,
  );
}



// WEBPACK FOOTER //
// ./src/scripts/sagas/gates.js